import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack } from '@mui/material';
export const ActionButtons = ({ disableSave, onSave, onCancel }) => {
    return (_jsxs(Stack, { spacing: 2, children: [_jsx(Button, { disabled: disableSave, variant: 'contained', onClick: () => onSave(), children: 'Save' }), _jsx(Button, { variant: 'outlined', onClick: () => onCancel(), children: 'Cancel' })] }));
};
